<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<script>
import store from "@/store";
export default {
  data() {
    return {};
  },
  // 监听,当路由发生变化的时候执行
  mounted() {
    // 获取路由上的携带参数
    const params = this.$route.query;
    if (params) {
      console.log(params, "router");
    }
  },
  methods: {},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue